import { Component, Input } from '@angular/core';
import { Categorization } from 'src/app/models/translate-results.model';
import { CategorizerLabelComponent } from '../../pipelines/categorizer-label/categorizer-label.component';

@Component({
    selector: 'app-categorization',
    templateUrl: './categorization.component.html',
    styleUrls: ['./categorization.component.css'],
    imports: [CategorizerLabelComponent]
})
export class CategorizationComponent {

  @Input()
  public categorizations: Categorization[];

}
